import ReviewsCarousel from './ReviewsCarousel';
import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import TelStoreCover from './TelStoreCover';
import { RedesignFooter, RedesignHeader, RedesignPage, SiteLink } from './RedesignShell';

const categories = [
  'Все работы',
  'Сайты и лендинги',
  'Интернет-магазины',
  'Мобильные приложения',
  'Мини-приложения VK / Telegram / MAX',
  'SEO-результаты',
  'Продвижение в Яндекс.Картах',
];

const cases = [
  {
    href: '/portfolio/tech-store/',
    category: 'Интернет-магазины',
    title: 'Создание интернет-магазина техники в Москве',
    sphere: 'ритейл',
    stack: ['собственная CMS', 'SEO', 'реклама'],
    result: 'рост органического трафика на 40% за 3 месяца',
  },
  {
    href: '/portfolio/sokolniki-restaurant/',
    image: '/images/cases/elite.webp',
    category: 'Сайты и лендинги',
    title: 'Разработка корпоративного сайта ресторана в Сокольниках под ключ',
    sphere: 'ресторан',
    stack: ['индивидуальная CMS', 'SEO', 'реклама'],
    result: 'рост трафика, увеличение бронирований и стабильный поток заявок через сайт',
  },
  {
    href: '/portfolio/fitness-course-landing/',
    image: '/images/cases/meditation-platform.webp',
    category: 'Сайты и лендинги',
    title: 'Разработка лендинга онлайн-курса по тренировкам под ключ',
    sphere: 'онлайн-курс',
    stack: ['структура', 'дизайн', 'SEO'],
    result: 'рост трафика на 320%, увеличение продаж курса на 185%',
  },
];

const benefits = [
  {
    title: 'Работаем от задачи, а не от бюджета',
    text: 'Перед стартом проекта мы не берем деньги «за разработку сразу». Сначала анализируем бизнес, цели и процессы. Предлагаем только те решения, которые реально нужны и принесут результат.',
  },
  {
    title: 'Поддержка 24/7 после запуска',
    text: 'Проект не заканчивается на релизе. Мы обеспечиваем техническую поддержку сайта, мониторинг и оперативное реагирование на любые вопросы в режиме 24/7.',
  },
  {
    title: 'Не бросаем после сдачи проекта',
    text: 'Мы остаемся партнером после запуска. Помогаем развивать продукт, внедрять новые функции, улучшать UX и масштабировать проект вместе с бизнесом.',
  },
  {
    title: 'Соблюдаем сроки и фиксируем дедлайны',
    text: 'Работаем по четкому плану. Все этапы разработки контролируются, сроки фиксируются заранее и соблюдаются без срывов.',
  },
];

const facts = [
  '7 лет опыта разработки',
  '30+ крупных проектов',
  'от 1 млн ₽ средний чек в портфеле',
  '10+ специалистов в команде',
  '8+ месяцев средний LTV клиента',
  '100% положительных отзывов',
];

const reviews = [
  {
    name: 'Альбина У.',
    role: 'директор ветеринарной клиники',
    text: 'Работали над разработкой сайта услуг с нуля. Понравилось, что команда сначала разобралась в бизнесе, а не просто начала делать «как у всех». В итоге получили понятную структуру, удобный интерфейс и рост заявок уже в первый месяц после запуска.',
  },
  {
    name: 'Михаил Ш.',
    role: 'владелец студии танцев',
    text: 'Заказывали корпоративный сайт с интеграцией CRM. Всё сделали в срок, без срывов. После запуска не пропали, помогают с доработками и поддержкой. Отдельно отмечу оперативную реакцию, реально отвечают быстро, даже ночью.',
  },
  {
    name: 'Карина С.',
    role: 'директор по маркетингу ресторана',
    text: 'Обращались за редизайном и доработкой сайта. Провели аудит, показали слабые места и предложили конкретные решения. После внедрения улучшился UX и выросла конверсия. Чувствуется, что команда работает на результат, а не просто «закрывает проект».',
  },
];

function SectionHeader({ eyebrow, children, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <div className={`eyebrow${dark ? ' cyan' : ''}`}>— {eyebrow}</div>
        <h2>{children}</h2>
      </div>
      {description && <p className="sub">{description}</p>}
    </div>
  );
}

function WhyGrid({ items }) {
  return (
    <div className="why-grid">
      {items.map((item, index) => (
        <div className="why" key={item.title}>
          <div className="why-n">{String(index + 1).padStart(2, '0')}</div>
          <div className="why-title">{item.title}</div>
          <p className="why-d">{item.text}</p>
        </div>
      ))}
    </div>
  );
}

function PortfolioRedesignPage() {
  const [featuredCase, ...moreCases] = cases;

  return (
    <RedesignPage>
      <PageMeta
        title="Портфолио Fatality Studio — кейсы по разработке сайтов и мобильных приложений в Москве"
        description="Реальные проекты Fatality Studio: сайты, мобильные приложения, мини-приложения, интернет-магазины на собственной CMS. Проекты от 1 млн рублей, 7 лет опыта, 10+ специалистов"
      />
      <RedesignHeader />

      <section className="ink hero" data-screen-label="portfolio hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-360px', width: '1000px', height: '1000px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="eyebrow cyan">— портфолио</div>
          <h1>
            <span className="accent">Портфолио</span>
          </h1>
          <p className="hero-sub">
            Реальные проекты — реальные результаты. Сайты, мобильные приложения, экосистемы и AI-решения для бизнеса
            по всей России.
          </p>
          <div className="hero-ctas">
            <SiteLink href="#portfolio-lead" className="btn btn-primary">
              Обсудить проект
            </SiteLink>
            <SiteLink href="/about/" className="btn btn-ghost-dark">
              О компании
            </SiteLink>
          </div>
          <div className="hero-meta portfolio-hero-meta">
            {facts.slice(0, 4).map((item, index) => (
              <div key={item}>
                <div className="num">
                  {String(index + 1).padStart(2, '0')}
                  <span>/</span>
                </div>
                <div className="lbl">{item}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad" data-screen-label="portfolio categories">
        <div className="container">
          <h2 className="sr-only">Фильтр по категориям</h2>
          <div className="category-filter portfolio-filter" aria-label="Фильтр по категориям">
            {categories.map((item, index) => (
              <button className={`category-chip${index === 0 ? ' active' : ''}`} type="button" key={item}>
                {item}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad" style={{ paddingTop: 0 }} data-screen-label="portfolio cases">
        <div className="container">
          <div className="section-top-line">
            <SectionHeader eyebrow="кейсы">Наши проекты</SectionHeader>
            <div className="case-spot">
              <div className="case-visual portfolio-featured-visual case-image-preview">
                <TelStoreCover preview alt={featuredCase.title} />
                <span className="case-visual-tag">{featuredCase.category}</span>
                <div className="case-visual-meta">{featuredCase.result}</div>
              </div>
              <div className="case-body">
                <div className="eyebrow">— кейс</div>
                <h3>
                  <SiteLink href={featuredCase.href} className="case-title-link">
                    {featuredCase.title}
                  </SiteLink>
                </h3>
                <dl>
                  <div>
                    <dt>Категория</dt>
                    <dd>{featuredCase.category}</dd>
                  </div>
                  <div>
                    <dt>Сфера</dt>
                    <dd>{featuredCase.sphere}</dd>
                  </div>
                  <div>
                    <dt>Стек</dt>
                    <dd>{featuredCase.stack.join(' · ')}</dd>
                  </div>
                  <div style={{ borderBottom: 0 }}>
                    <dt>Результат</dt>
                    <dd>
                      <b>{featuredCase.result}</b>
                    </dd>
                  </div>
                </dl>
                <SiteLink href={featuredCase.href} className="link-flat" style={{ marginTop: '8px' }}>
                  Смотреть кейс →
                </SiteLink>
              </div>
            </div>

            <div className="blog-grid portfolio-more-grid">
              {moreCases.map((item) => (
                <div className="article" key={item.href}>
                  <div className="article-img">
                    {item.image ? <img className="case-card-image" src={item.image} srcSet={`${item.image.replace(".webp", "-840.webp")} 840w, ${item.image.replace(".webp", "-1280.webp")} 1280w, ${item.image} 1672w`} sizes="(max-width: 640px) calc(100vw - 40px), 50vw" alt={item.title} width="1672" height="941" loading="lazy" /> : <><div className="article-img-pat portfolio-article-pattern" /><span className="ph">{item.category}</span></>}
                  </div>
                  <div className="article-meta">
                    <span className="article-tag">{item.sphere}</span>
                    <span>{item.stack.join(' · ')}</span>
                  </div>
                  <h3 className="article-title">
                    <SiteLink href={item.href}>{item.title}</SiteLink>
                  </h3>
                  <p className="article-desc">{item.result}</p>
                  <SiteLink href={item.href} className="link-flat">Смотреть кейс →</SiteLink>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="ink sec-pad" data-screen-label="portfolio benefits">
        <div className="container">
          <SectionHeader dark eyebrow="результат">
            Что вы получаете <span className="accent">работая с нами</span>
          </SectionHeader>
          <WhyGrid items={benefits} />
        </div>
      </section>

      <section className="canvas sec-pad" data-screen-label="portfolio facts">
        <div className="container">
          <SectionHeader eyebrow="цифры">Цифры говорят сами за себя</SectionHeader>
          <div className="trust-grid facts-trust-grid">
            {facts.map((item, index) => (
              <div className="trust" key={item}>
                {item}
                <span className="role">{String(index + 1).padStart(2, '0')}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad" id="reviews" data-screen-label="portfolio reviews">
        <div className="container">
          <SectionHeader dark eyebrow="отзывы">
            Отзывы <span className="accent">клиентов</span>
          </SectionHeader>
          <ReviewsCarousel className="why-grid review-why-grid">
            {reviews.map((review, index) => (
              <figure className="why review-why" aria-label={`${review.name}, ${review.role}`} key={review.name}>
                <div className="why-n">{String(index + 1).padStart(2, '0')}</div>
                <blockquote>{review.text}</blockquote>
                <figcaption>
                  <b>{review.name}</b>
                  <span>{review.role}</span>
                </figcaption>
              </figure>
            ))}
          </ReviewsCarousel>
        </div>
      </section>

      <section className="ink lead" id="portfolio-lead" data-screen-label="portfolio lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <div className="eyebrow cyan">— заявка</div>
              <h2 className="lead-heading">Готовы стать следующим кейсом?</h2>
              <p className="lead-text">
                Расскажите о своём проекте — мы предложим решение и покажем похожие работы из портфолио на первом же
                звонке.
              </p>
              <SiteLink href="/about/" className="btn btn-ghost-dark section-action">
                О компании
              </SiteLink>
            </div>
            <LeadForm
              formId="portfolio-lead-form"
              idPrefix="portfolio"
              contactLabel="Телефон"
              contactType="tel"
              contactPlaceholder="+7 (___) ___-__-__"
              showCompany={false}
              submitLabel="Обсудить проект"
              taskPlaceholder="Расскажите о своём проекте"
            />
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default PortfolioRedesignPage;
